import { ResendOTP } from "./../_models/login/LoginResponseModel";
import { ReportsService } from "./../_services/reports/reports.service";
import "rxjs/add/operator/catch";

import { Observable } from "rxjs/Rx";
import * as shajs from "sha.js";

import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    AfterViewInit,
    ViewContainerRef,
    ViewEncapsulation,
    trigger,
    state,
    style,
    transition,
    group,
    animate,
    ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";

import { GlobalService } from "../_global/global.service";
import { LoginRequestModel, LoginResponseModel } from "../_models/index";
import { ForgotPasswordRequestModel } from "../_models/login/ForgotPasswordRequestModel";
import {
    ResetPasswordRequestModel,
    UpdatePasswordRequest,
} from "../_models/login/ResetPasswordRequestModel";
import { LoginService } from "../_services/index";
import { ScriptLoaderService } from "../_services/script-loader/script-loader.service";
import { Helpers } from "../helpers";
import { AlertComponent } from "./_directives/alert.component";
import { LoginCustom } from "./_helpers/login-custom";
import { AlertService } from "./_services/alert.service";
import { AuthenticationService } from "./_services/authentication.service";
import { UserService } from "./_services/user.service";
import {
    PartnerMobileRequest,
    PartnerOtpValidateRequest,
    PartnerOnBoardRequest,
} from "../_models/login/LoginResponseModel";
import { PartnerService } from "../_services/partner/partner.service";
import { LogoutComponent } from "./logout/logout.component";
import { stringify } from "@angular/core/src/util";

declare var $: any;
declare var swal: any;

@Component({
    selector: ".m-grid.m-grid--hor.m-grid--root.m-page",
    templateUrl: "./templates/login-2.component.html",
    styleUrls: ["./templates/login-2.component.scss"],
    providers: [ReportsService],
    encapsulation: ViewEncapsulation.None,
})
export class AuthComponent implements OnInit, AfterViewInit {
    private _gs: GlobalService = new GlobalService();

    footerYear: Date = new Date();
    uiList = new Array<any>();
    model: any = {};
    forgotPasswordModel = new ForgotPasswordRequestModel();
    updatePasswordModel = new ResetPasswordRequestModel();
    updatePasswordRequest = new UpdatePasswordRequest();
    partnerMobileRequest = new PartnerMobileRequest();
    partnerOtpValidateRequest = new PartnerOtpValidateRequest();
    partnerOnBoardRequest = new PartnerOnBoardRequest();

    loading = false;
    returnUrl: string;
    currentUser: LoginResponseModel;
    resendOTPModel = new ResendOTP();
    error: string = null;
    message: string = null;
    verificationValue;
    newPasswordForgot;
    newPassword1: string = null;
    newPassword2: string = null;
    confirmPassword: string;
    isChecked: boolean = true;
    @ViewChild("alertSignin", { read: ViewContainerRef })
    alertSignin: ViewContainerRef;
    @ViewChild("alertSignup", { read: ViewContainerRef })
    alertSignup: ViewContainerRef;
    @ViewChild("alertForgotPass", { read: ViewContainerRef })
    alertForgotPass: ViewContainerRef;
    menuComissionState: string = "out";
    orderComissionState: string = "out";
    partnerMobile: any;
    partnerPan: any;
    isCorporatePan = false;
    showPartnerName = false;
    partnerFirstName: any;
    partnerLastName: any;
    partnerName: any;
    partnerEmail: any;
    clientLat: any;
    clientLong: any;
    clientBrowser = "";
    geolocationPosition: any;
    notificationMessage: any;
    priority: any;
    currentUrl: any;
    lenght: any;
    uipermissionList = new Array<any>();
    passwordValidation: any;
    showError: boolean = false;
    selectedBranch: string = "";
    branchList: any[] = [];
    API_URL: string;

    constructor(
        private _router: Router,
        private _script: ScriptLoaderService,
        private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        private _alertService: AlertService,
        private _loginService: LoginService,
        private cfr: ComponentFactoryResolver,
        private _reportsService: ReportsService,
    ) {
        sessionStorage.setItem("lastapirequeststart", "false");
    }

    ngOnInit() {
        this.getBranches();
        this.getPasswordResetNote();
        this.getIPDetails();
        this.getLocation();
        this.model.remember = true;

        // get return url from route parameters or default to '/'
        this.currentUrl = window.location.pathname;
        // this.uipermissionList = this._gs.currentUser.uiPermissions;
        // if(this.uipermissionList.includes('SECURE_SMART')){
        //     this.returnUrl = "/secuDashBoard"
        // }else{
        //     this.returnUrl = "/dashboard";
        // }
        this.returnUrl = "/dashboard";
        this.API_URL = this._loginService.API_URL;
        //  this.returnUrl = this._route.snapshot.queryParams["returnUrl"] || "/login";
        // this._router.navigate([this.returnUrl]);
        this._script
            .loadScripts(
            "body",
            [
                "assets/vendors/base/vendors.bundle.js",
                "assets/demo/demo2/base/scripts.bundle.js",
            ],
            true,
        )
            .then(() => {
                Helpers.setLoading(false);
                LoginCustom.init();
            });
        $(".info-item .btn").click(function() {
            $(".kontainer").toggleClass("sign-up");
        });
        $(".kontainer").toggleClass("sign-up");
        $(".m-registermobile__form-action  .btn-secondary").click(function() {
            $(".kontainer").toggleClass("sign-up");
        });
    }

    scroll(el: any) {
        el.scrollIntoView({ behavior: "smooth" });
    }

    fogot() {
        this.forgotPasswordModel.id = this.model.email;
    }
    ngAfterViewInit() {
        this._script.loadScripts(".m-grid.m-grid--hor.m-grid--root.m-page", [
            "assets/snippets/pages/user/login.js",
        ]);

        Helpers.bodyClass(
            "m--skin- m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default",
        );

        if (this.currentUrl == "/login/wsfx") {
            sessionStorage.removeItem("currentUser");
            sessionStorage.removeItem("X-AUTH-TOKEN");
            swal(
                "Session Expired",
                "Your Login Session is expired! Please login again to continue.",
                "info",
            );
        }

        setTimeout(() => {
            const el = document.querySelector(".kontainer-form") as HTMLElement;
            const content = el.scrollHeight;
            el.style.height = content + "px";
        });
    }
    onCheckBoxClick() {
        this.isChecked = !this.isChecked; // this will change value of it true and false
    }

    signinx() {
        this.loading = true;
        this._authService.login(this.model.email, this.model.password).subscribe(
            (data) => {
                this._router.navigate([this.returnUrl]);
            },
            (error) => {
                this.showAlert("alertSignin");
                this._alertService.error(error);
                this.loading = false;
            },
        );
    }

    clearData() {
        this.partnerMobileRequest = new PartnerMobileRequest();
    }

    getBranches() {
        this._loginService.getBranches().subscribe((res) => {
            this.branchList = res.json();
            console.log("branchList:::::", this.branchList);
        });
    }
    getLocation() {
        if (window.navigator && window.navigator.geolocation) {
            window.navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.geolocationPosition = position;

                    this.clientLat = position["coords"]["latitude"];
                    this.clientLong = position["coords"]["longitude"];
                    sessionStorage.setItem("Latitude", this.clientLat);
                    this.clientLong = position["coords"]["longitude"];
                    sessionStorage.setItem("Longitude", this.clientLat);
                },
                (error) => { },
            );

            this.clientBrowser = navigator.platform;
        }
    }
    getIPDetails() {
        this._reportsService.getIpDetails().subscribe((data) => {
            let ip = JSON.parse(data["_body"]).ip;
            sessionStorage.setItem("IP", ip);
        });
    }

    getPasswordResetNote() {
        var channel = "ADMIN_PORTAL";
        this._loginService.getPasswordResetNote(channel).subscribe(
            (resp) => {
                var body = resp.json();
                var bodyHere = body.note;
                this.passwordValidation = bodyHere;
                console.log("resp_+_+", this.passwordValidation);
            },
            (error) => { },
        );
    }

    signin() {
        this.loading = true;

        this.model.email = this.model.email.trim();
        this.model.password = this.model.password.trim();

        const loginModel = new LoginRequestModel(
            this.model.email,
            shajs("sha256").update(this.model.password).digest("hex") + "@1",
        );

        sessionStorage.setItem(
            "X-PORTAL-TOKEN",
            shajs("sha256")
                .update(
                "8c6976e5b5410415bde908bd4dee15dfb167a9c873fc4bb8a81f6f2ab448a918" +
                this.model.email,
            )
                .digest("hex"),
        );

        this._loginService.login(loginModel).subscribe(
            (result) => {
                this.currentUser = result.json();

                console.log(
                    "currentUser before merge",
                    JSON.parse(JSON.stringify(this.currentUser)),
                );

                let normalUiPermissions: any[] = [];
                let cpdUiPermissions: any[] = [];

                if (
                    this.currentUser.uiPermissions &&
                    Array.isArray(this.currentUser.uiPermissions)
                ) {
                    normalUiPermissions = this.currentUser.uiPermissions;
                }

                if (
                    this.currentUser.cpdUiPermissions &&
                    Array.isArray(this.currentUser.cpdUiPermissions)
                ) {
                    cpdUiPermissions = this.currentUser.cpdUiPermissions;
                }

                const mergedPermissions = Array.from(
                    new Set([...normalUiPermissions, ...cpdUiPermissions]),
                );

                this.currentUser.uiPermissions = mergedPermissions;

                this.uiList = mergedPermissions;
                this.uipermissionList = mergedPermissions;

                console.log("normalUiPermissions", normalUiPermissions);
                console.log("cpdUiPermissions", cpdUiPermissions);
                console.log("mergedPermissions", mergedPermissions);

                console.log(
                    "currentUser after merge",
                    JSON.parse(JSON.stringify(this.currentUser)),
                );

                if (this.model.email == this.currentUser.email) {
                    this.notificationMessage =
                        this.currentUser.notificationMessageResponses;

                    this.priority =
                        this.currentUser.notificationMessageResponses.notificationPriority;

                    sessionStorage.setItem("cdpRole", this.currentUser["cdpRole"]);
                    sessionStorage.setItem(
                        "cdpDepartment",
                        this.currentUser["department"],
                    );

                    if (this.currentUser["partnerStatus"] == "READ_ONLY") {
                        this.loading = false;

                        swal(
                            "",
                            "Your online access to WSFX Partner portal is under process. You are requested to call us on +91-9136090052 or mail us on support@wsfx.in to activate your account.",
                            "info",
                        );
                    } else {
                        if (
                            this.currentUser.photo === null ||
                            this.currentUser.photo === undefined
                        ) {
                            if (this.currentUser.firstName && this.currentUser.lastName) {
                                this.currentUser.photo =
                                    this.currentUser.firstName.toString().charAt(0) +
                                    this.currentUser.lastName.toString().charAt(0);

                                this.currentUser.photo =
                                    "data:image/JPEG" + this.currentUser.photo;
                            }
                        }

                        sessionStorage.setItem(
                            "currentUser",
                            JSON.stringify(this.currentUser),
                        );

                        sessionStorage.setItem(
                            "X-AUTH-TOKEN",
                            JSON.stringify({
                                token: result.headers.get("X-AUTH-TOKEN"),
                            }),
                        );

                        this._gs.currentUser = this.currentUser;

                        sessionStorage.setItem(
                            "timeOutInSeconds",
                            this.currentUser.timeOutInSeconds,
                        );

                        sessionStorage.setItem("lastapirequeststart", "true");

                        sessionStorage.setItem(
                            "tourOperatorReferrer",
                            this.currentUser.tourOperatorReferrer + "",
                        );

                        sessionStorage.setItem("lastapirequest", Date.now().toString());

                        sessionStorage.setItem(
                            "showFxCalculator",
                            this.currentUser.partner.showFxCalculator + "",
                        );

                        sessionStorage.setItem(
                            "bulkOrderAllowed",
                            this.currentUser.partner.bulkOrderAllowed + "",
                        );

                        sessionStorage.setItem(
                            "showRateRange",
                            this.currentUser.partner.showRateRange + "",
                        );

                        this.loading = false;

                        this._router.navigate(["/dashboard"]);
                    }
                } else {
                    this.loading = false;
                    swal("Error", "Please enter valid credentials!!!", "error");
                }
            },
            (error) => {
                console.log("error._body >>>", error._body);

                this.loading = false;

                const errorReason = JSON.parse(error._body).reason;

                if (
                    errorReason == "INACTIVE_PARTNER" ||
                    errorReason == "USER_NOT_ACTIVE"
                ) {
                    swal(
                        "Error",
                        "This account is <b>INACTIVE</b>.<br/> Please contact your Admin for further assistance!",
                        "error",
                    );
                }

                if (
                    errorReason == "INVALID_CREDENTIALS" ||
                    errorReason == "INVALID_REQUEST_PARAMETER"
                ) {
                    swal("Login Error", "Invalid Username or Password", "error");
                }

                if (errorReason == "PASSWORD_NOT_UPDATED") {
                    LoginCustom.displayLoginResetPassword();
                }

                if (errorReason == "PORTAL_USER_MISMATCH") {
                    const msg = JSON.parse(error._body).message;
                    swal("Login Error", msg, "error");
                }
            },
        );
    }

    signup() {
        this.loading = true;
        this._userService.create(this.model).subscribe(
            (data) => {
                this.showAlert("alertSignin");
                this._alertService.success(
                    "Thank you. To complete your registration please check your email.",
                    true,
                );
                this.loading = false;
                LoginCustom.displaySignInForm();
                this.model = {};
            },
            (error) => {
                this.showAlert("alertSignup");
                this._alertService.error(error);
                this.loading = false;
            },
        );
    }
    requestOTP() {
        // debugger
        this.loading = true;
        this._loginService.preOnBoard(this.partnerMobileRequest).subscribe(
            (data) => {
                this.loading = false;
            },
            (error) => {
                this.loading = false;
            },
        );
    }
    forgotPass() {
        this.loading = true;
        this.forgotPasswordModel.type = "otp";
        this._loginService.getOTP(this.forgotPasswordModel).subscribe(
            (data) => {
                this.showAlert("alertSignin");
                this.loading = false;
                LoginCustom.displayUpdatePasswordForm();
            },
            (error) => {
                let errorReason = JSON.parse(error._body).reason;
                if (
                    errorReason == "INACTIVE_PARTNER" ||
                    errorReason == "USER_NOT_ACTIVE"
                ) {
                    swal(
                        "Error",
                        "This account is <b>INACTIVE</b>.<br/> Please contact your Admin for further assistance!",
                        "error",
                    );
                }
                this.showAlert("alertForgotPass");
                this._alertService.error(error.json().message);
                this.loading = false;
            },
        );
    }
    mobileBack() {
        $("#m-registermobile__form").resetForm();
        $(".form-control-feedback").hide();
    }
    // otpBack() {
    //     $("#m-registerotp__form").resetForm();
    //     $(".form-control-feedback").hide();
    // }
    setForgetPassword() {
        this.forgotPasswordModel.id = this.model.email;
    }
    forgottenPasswordReset() {
        $("#m-forgot__form").resetForm();
        $(".form-control-feedback").hide();
        this.forgotPasswordModel.id = null;
        this.clearAlert("alertForgotPass");
    }

    updatePass() {
        this.loading = true;
        this.updatePasswordModel.verificationType = "otp";
        this.updatePasswordModel.email = this.forgotPasswordModel.id;
        var validateModel = {
            password: this.updatePasswordModel.newPassword,
        };
        if (this.updatePasswordModel.newPassword == this.confirmPassword) {
            this._loginService.passwordValidate(validateModel).subscribe(
                (resp) => {
                    this._loginService.updatePassword(this.updatePasswordModel).subscribe(
                        (data) => {
                            this.showAlert("alertSignin");
                            this._alertService.success(
                                "Your Password  has been reset successfully.",
                                true,
                            );
                            this.loading = false;
                            this.updatePasswordModel = new ResetPasswordRequestModel();
                            this.confirmPassword = null;
                            this.newPasswordForgot = null;
                            LoginCustom.displaySignInForm();
                        },
                        (error) => {
                            this.loading = false;
                            let errorMessage = error.json();
                            this.updatePasswordModel = new ResetPasswordRequestModel();
                            this.confirmPassword = null;
                            this.updatePasswordModel.newPassword = null;
                            if (errorMessage.reason == "INVALID_OTP") {
                                swal("Invalid OTP. Please enter a correct OTP");
                                return;
                            }
                            swal("Error...", errorMessage.message, "error");
                        },
                    );
                    this.model = {};
                },
                (error) => {
                    this.loading = false;
                    console.log(error);
                    // let errorReason = JSON.parse(error._body).reason;
                    this.updatePasswordModel = new ResetPasswordRequestModel();
                    this.confirmPassword = null;
                    this.updatePasswordModel.newPassword = null;
                    // console.log('errorMessage', errorReason);
                    // swal(error, errorMessage);
                },
            );
        } else {
            swal("New Password & Confirm Password should be same");
            this.error = "Enter Valid Password";
            this.loading = false;
        }
        // }
    }
    valueCheck() {
        console.log("this.confirmPassword()", this.confirmPassword);
        if (this.updatePasswordModel.newPassword != this.confirmPassword) {
            this.showError = true;
        } else {
            this.showError = false;
        }
    }
    updatePassResetForm() {
        this.updatePasswordModel = new ResetPasswordRequestModel();
        this.confirmPassword = null;
        $(".form-control-feedback").hide();
    }
    validateConfirmPassword() {
        this.updatePasswordModel.newPassword = this.newPasswordForgot;

        if (
            shajs("sha256")
                .update(this.updatePasswordModel.newPassword)
                .digest("hex") +
            "@1" ==
            shajs("sha256").update(this.confirmPassword).digest("hex") + "@1"
        ) {
            this.updatePasswordModel.newPassword =
                shajs("sha256")
                    .update(this.updatePasswordModel.newPassword)
                    .digest("hex") + "@1";
            this.confirmPassword = this.updatePasswordModel.newPassword;
            return true;
        } else {
            swal({
                type: "error",
                title: "Error!",
                text: "New Password & Confirm Password are not matching",
                confirmButtonText: "OK",
            });
        }
    }
    showAlert(target) {
        this[target].clear();
        let factory = this.cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.changeDetectorRef.detectChanges();
    }
    clearAlert(target) {
        this[target].clear();
    }
    resetPassword() {
        if (this.newPassword1 != null && this.newPassword1 === this.newPassword2) {
            this.loading = true;
            this.updatePasswordRequest.newPassword = this.newPassword1;
            // this.updatePasswordRequest.newPassword = shajs('sha256').update(this.updatePasswordRequest.newPassword).digest('hex') + '@1'
            this.updatePasswordRequest.verificationValue = this.model.password;
            // this.updatePasswordRequest.verificationValue = shajs('sha256').update(this.updatePasswordRequest.verificationValue).digest('hex') + '@1'
            this.updatePasswordRequest.verificationType = "password";
            this.updatePasswordRequest.email = this.model.email;
            console.log(this.updatePasswordRequest);
            var validateModel = {
                password: this.newPassword1,
            };
            this._loginService.passwordValidate(validateModel).subscribe(
                (resp) => {
                    this._loginService
                        .resetPassword(this.updatePasswordRequest)
                        .subscribe(
                        (res) => {
                            this.loading = false;
                            this.showAlert("alertSignin");
                            this._alertService.success(
                                "Your Password  has been reset successfully.",
                                true,
                            );
                            LoginCustom.displaySignInForm();
                            this.model = {};
                        },
                        (error) => {
                            this.loading = false;
                            let errorMessage = error.json();
                            if (errorMessage.reason == "INVALID_OTP") {
                                swal("Invalid OTP. Please enter a correct OTP");
                                return;
                            }

                            swal("Error...", errorMessage.message, "error");
                        },
                    );
                },
                (error) => {
                    this.loading = false;
                    console.log(error);
                    // let errorReason = JSON.parse(error._body).reason;
                    this.updatePasswordRequest = new UpdatePasswordRequest();
                    this.newPassword1 = null;
                    this.newPassword2 = null;
                    // console.log('errorMessage', errorReason);
                    // swal(error, errorMessage);
                },
            );
        } else {
            swal("New Password & Confirm Password should be same");
            this.error = "Enter Valid Password";
        }
    }
    private handleError(error: Response | any) {
        this.error = error.json().error;
        this.message = error.json().message;
        if (error.status === 401) {
            return Observable.throw(error);
        } else {
            swal("LoginError", "Invalid Username or Password", "error");
            return Observable.throw(this.error || this.message || "Server Error"); // <= B
        }
    }

    // REGISTRATION PROCESS
    getOtpForValidation() {
        this.loading = true;

        this.partnerMobile = this.partnerMobileRequest.mobile;
        this.partnerPan = this.partnerMobileRequest.pan;
        this._loginService.preOnBoard(this.partnerMobileRequest).subscribe(
            (result) => {
                this.loading = false;
                LoginCustom.displayPartnerRegisterOTP();
            },
            (error) => {
                this.loading = false;
                let err = error.json();
                let errorMessage = err.message;
                swal("Error", errorMessage, "error");
            },
        );
    }
    resendOTP() {
        this.resendOTPModel.mobile = this.partnerMobileRequest.mobile;
        this._loginService.resendOTP(this.resendOTPModel).subscribe(
            (result) => {
                swal(
                    "OTP resent successfully on" + " " + this.partnerMobileRequest.mobile,
                );
            },
            (error) => {
                let err = error.json();
                let errorMessage = err.message;
                swal("Error", errorMessage, "error");
            },
        );
    }

    validateOTP() {
        this.loading = true;
        this.partnerOtpValidateRequest.mobile = this.partnerMobileRequest.mobile;
        this._loginService
            .verifyPartnerRegistrationOtp(this.partnerOtpValidateRequest)
            .subscribe(
            (result) => {
                this.partnerOnBoardRequest = result.json();

                this.partnerOnBoardRequest.mobile = this.partnerMobile;
                this.partnerOnBoardRequest.pan = this.partnerMobileRequest.pan;
                if (this.partnerOnBoardRequest.firstName != null) {
                    this.partnerFirstName = this.partnerOnBoardRequest.firstName;
                    this.partnerLastName = this.partnerOnBoardRequest.lastName;
                }
                if (this.partnerOnBoardRequest.partnerName != null) {
                    this.partnerName = this.partnerOnBoardRequest.partnerName;
                }
                LoginCustom.displayPartnerRegisterFinalStep();
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                let err = error.json();
                let errorMessage = err.message;
                this.partnerOtpValidateRequest = new PartnerOtpValidateRequest();
                this.partnerOtpValidateRequest.mobile =
                    this.partnerMobileRequest.mobile;

                swal("Error", errorMessage, "error");
            },
        );
    }

    onBoardPartner() {
        this.loading = true;
        this.partnerOnBoardRequest.partnerName = this.partnerName;
        this.partnerEmail = this.partnerOnBoardRequest.email;
        if (this.partnerFirstName != null) {
            this.partnerOnBoardRequest.firstName = this.partnerFirstName;
        }
        if (this.partnerLastName != null) {
            this.partnerOnBoardRequest.lastName = this.partnerLastName;
        }
        if (this.partnerName != null) {
            this.partnerOnBoardRequest.partnerName = this.partnerName;
        }

        if (this.selectedBranch) {
            this.partnerOnBoardRequest.branchId = this.selectedBranch;
        }

        this._loginService.onBoardPartner(this.partnerOnBoardRequest).subscribe(
            (result) => {
                this.loading = false;
                LoginCustom.displayPartnerRegister();
                swal(
                    "Success",
                    "Congratulations! Your registration was successful! Our team will get in touch with you for further processing.",
                    "success",
                );
                this.partnerOnBoardRequest = new PartnerOnBoardRequest();
                this.partnerMobileRequest = new PartnerMobileRequest();
                this.partnerOtpValidateRequest = new PartnerOtpValidateRequest();
            },
            (error) => {
                this.loading = false;
                let err = error.json();
                let errorMessage = err.message;
                // this.partnerOnBoardRequest = new PartnerOnBoardRequest();
                swal("Error", errorMessage, "error");
            },
        );
    }

    showDisclaimer() {
        swal({
            title: "Disclaimer",
            customClass: "textDisclaimer",
            html:
            "WSFX does not guarantee the accuracy, adequacy or completeness of any information and is not responsible for any errors or omissions or for the results obtained from the use of such information. WSFX especially states that it has no financial liability whatsoever to any user on account of the use of information provided on its website. WSFX does not warrant the accuracy, adequacy or completeness of this information and material and expressly disclaims liability for errors or omissions in this information and material. WSFX is not responsible for any errors, omissions or representations on any of our pages or on any links on any of our pages. Please verify the veracity of all information on your own before undertaking any trade or alliance. These results should therefore be used only as a guide. You can contact or visit our branch in order to obtain the actual rate available at time of exchange.<br><br>" +
            "There are risks associated with utilizing internet. Subscribers are advised to understand that the services can fail due to failure of hardware, software, and Internet connection. WSFX hereby expressly disclaims any implied warranties imputed by the laws of any jurisdiction. We consider ourselves and intend to be subject to the jurisdiction only of the courts of Mumbai in India. If you don't agree with any of our disclaimers above please do not rely on information shared on any of our pages. This site is specifically for users in the territory of India. <br><br>" +
            "Although the access to users outside India is not denied, WSFX shall have no legal liabilities whatsoever in any laws of any jurisdiction other than India. We reserve the right to make changes to our site and these disclaimers, terms, and conditions at any time. Money exchange rates & its trade is inherently risky and you agree to assume complete and full responsibility for the outcomes of all trading decisions that you make, including but not limited to loss of capital. The information is not meant to be an endorsement or offering of any purchase. They are meant to be a guide only, which must be tempered by experience and independent decision making process of the viewer.<br><br>" +
            "Thus this information is NOT a recommendation or solicitation to buy or sell any of foreign currency. By using this website including any software and content contained therein, you agree that use of the Service is entirely at your own risk and WSFX is not responsible thereof.",
            buttons: { cancel: true },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts